import React from 'react'
import Header from './Header'
import "./Skills.css"

const Skills = () => {
  return (
    <div className="skill">
     

        <div className="skills">
          <h1 className="skills__header">
            My skills
          </h1>

          <div className="skills__info">
            <div className="skill__desc">
              <h2>
                My creative skills & experiences
              </h2>
              <p>The first programming language I learnt was python.  After
			          some time and with a lot of practice and experience, I needed a goal. I then chose to pursue Web Development. 
			          i start to learn HTML and CSS, and it did not take long as it was super easy to learn.<br /> I then start to learn Javascript, and play around with algoithms it offered. 
			          Since I had prior knowledge of python, it was also super easy, and it felt like I was going over what I learnt already, just a different application this time. 
			          Then I wanted to learn more, and I started to hear about libraries. And then I started to focus on React.js.<br /> I have been hooked since then, and I hope to learn more.</p>
            </div>
            <div className="skills__bars">
              <div className="html">
                <h1>
                  HTML
                </h1>
                <p>
                  90%
                </p>
              </div>

              <div className="css">
                <h1>
                  CSS
                </h1>
                <p>
                  85%
                </p>
              </div>

              <div className="js">
                <h1>
                  JavaScrips
                </h1>
                <p>
                  80%
                </p>
              </div>

              <div className="react">
                <h1>
                  REACT
                </h1>
                <p>
                  95%
                </p>
              </div>

              <div className="python">
                <h1>
                  PYTHON
                </h1>
                <p>
                  80%
                </p>
              </div>

            </div>
          </div>
        </div>
        
    </div>
  )
}

export default Skills